import { NAV, WHATSAPP_URL, WHATSAPP_DISPLAY, CONTACT_EMAIL, LEGAL_LINE } from "../content";
import { scrollToId } from "../lib/lenis";
import { WhatsAppIcon } from "../lib/icons";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-tinta border-t border-inkline py-14 md:py-16"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <img
            src="/assets/logo-horizontal.webp"
            alt="DealFlow Lab"
            className="h-10 w-auto"
          />
          <p className="mt-5 text-muteddark text-sm max-w-xs leading-relaxed">
            Growth com método. Resultado com números.
          </p>
        </div>

        <nav className="flex flex-col gap-3" aria-label="Navegação do rodapé">
          <span className="label-caps text-muteddark !text-[10px] mb-1">Navegação</span>
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`footer-link-${item.id}`}
              onClick={() => scrollToId(item.id)}
              className="text-left font-sora text-sm font-semibold text-creme/80 hover:text-lima transition-colors duration-150"
            >
              {item.label}
            </button>
          ))}
          <a
            data-testid="footer-link-privacidade"
            href="/privacidade"
            className="font-sora text-sm font-semibold text-creme/80 hover:text-lima transition-colors duration-150"
          >
            Política de Privacidade
          </a>
        </nav>

        <div className="flex flex-col gap-3">
          <span className="label-caps text-muteddark !text-[10px] mb-1">Contato</span>
          <a
            data-testid="footer-whatsapp-link"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2.5 font-sora text-sm font-semibold text-creme/80 hover:text-lima transition-colors duration-150"
          >
            <WhatsAppIcon className="w-4 h-4 text-lima" /> {WHATSAPP_DISPLAY}
          </a>
          <a
            data-testid="footer-email-link"
            href={`mailto:${CONTACT_EMAIL}`}
            className="font-sora text-sm font-semibold text-creme/80 hover:text-lima transition-colors duration-150"
          >
            {CONTACT_EMAIL}
          </a>
        </div>
      </div>

      <p
        data-testid="footer-legal"
        className="mt-12 pt-8 border-t border-inkline text-xs text-muteddark/70 leading-relaxed"
      >
        {LEGAL_LINE}
      </p>
    </div>
  </footer>
);
